/**
 * Test if a provided object is a Blueprint Component
 *
 * @param obj Object to test
 */
// Would prefer to do 'obj instanceof BlueprintComponent' here, but it
// causes unresolvable circular dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBlueprintComponent = (obj) => 'init' in obj && 'isElementAvailable' in obj && 'getElement' in obj;
/**
 * Test if a provided object is a Jsx Component
 *
 * @param obj Object to test
 */
// Would prefer to do 'obj instanceof JsxComponent' here, but it
// causes unresolvable circular dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isJsxComponent = (obj) => 'createElement' in obj;
